module.exports = __webpack_public_path__ + "catalog/items/monitor-pc/power.jpg";